import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { RestHttp } from "../rest-http.service";

@Injectable()
export class MartAuthApi {
  private basePath = "/mart-auth/auth/actions";

  constructor(private rest: RestHttp) {}

  login(globalJwt: string): Observable<{ jwt: string }> {
    interface Response {
      data: {
        jwt: string;
      };
    }

    return this.rest
      .post<null, Response>(`${this.basePath}/login`, null, undefined, "json", {
        authorization: `Bearer ${globalJwt}`
      })
      .pipe(map((envelope) => envelope.data));
  }

  // check jwt is still valid (use to re-login if already logged in)
  verifyToken(jwt: string): Observable<{ valid: boolean; expiresAt?: Date }> {
    interface Response {
      data: {
        valid: boolean;
        expiresAt?: string;
      };
    }

    return this.rest
      .post<null, Response>(
        `${this.basePath}/verify-token`,
        null,
        undefined,
        "json",
        {
          authorization: `Bearer ${jwt}`
        }
      )
      .pipe(
        map((envelope) => {
          const { valid, expiresAt } = envelope.data;
          return {
            valid,
            expiresAt: expiresAt != null ? new Date(expiresAt) : undefined
          };
        })
      );
  }

  logout(jwt: string): Observable<{ success: boolean }> {
    return this.rest.post(`${this.basePath}/logout`, null, undefined, "json", {
      authorization: `Bearer ${jwt}`
    });
  }
}
